import { Component, OnInit, OnDestroy } from '@angular/core';
import {AppDataService} from "../../../services/app-data.service";
import {FormBuilder, FormGroup} from "@angular/forms";
import {CompanyService} from "../../../services/company.service";
import { TranslationService } from '../../../services/translation.service';
import { BaseActionComponent } from './baseAction';


declare let $: any;
declare let Swal:any;

@Component({
    selector : 'door-action',
    templateUrl:'doorAction.html'
})
export class DoorActionComponent extends BaseActionComponent{

  public linkForm: FormGroup;
  public option
  public level=1;
  public roomToGo='';
  public rooms;
  public room;
  public spaces;
  public space;

  public constructor(public translate: TranslationService,public _appData : AppDataService,public fb : FormBuilder, public _companyService : CompanyService) {
    super(translate,_appData,fb,_companyService);
    this.linkForm = this.fb.group({
        roomToGo:'',
        teleport:false,
        direct:false,
        x:0,
        y:0,
        z:0,
        xIn:0,
        yIn:0,
        zIn:0,
        xOut:0,
        yOut:0,
        zOut:0,
        nextAngle:0,
        space:0,
        voice:false,
        //senha opcional para atravessar a porta
        password:''
    });
  }
  public selectSpace(spaceid){
    this.spaces.forEach(r=>{
      if (r.id==spaceid){
        r.selected=true;
        this.space=r;
      }
      else{
        r.selected=false;
      }
    })
  }
  public selectRoom(value){

    let filter=this.rooms.filter(r=>{
      return r.id==value
    })
    this.room=filter[0];
    this.spaces=[]
    if (this.room.background2d && this.room.background2d.length>0){
      this.spaces=this.room.background2d
    }
    else 
      {
        if (this.room.background3d && this.room.background3d.length>0){
          this.spaces=this.spaces.concat(this.room.background3d)
        }
        if (this.room.backgroundPhoto && this.room.backgroundPhoto.length>0){
          this.spaces=this.spaces.concat(this.room.backgroundPhoto)
        }
    }


    let idx=0
    this.spaces.forEach(v=>{
      if (!v.id){
        v.id=idx
      }
      idx++;
    })
    if (this.action.param.space){
      let filter=this.spaces.filter(r=>{
        return r.id==this.action.param.space
      })

      this.space=filter[0]
    }
  }
  public whereIAm(option){
    let linkParam = this.linkForm['_value'];
    if (option=='in'){
      linkParam.xIn=this._appData.instagramUser.position.x
      linkParam.yIn=this._appData.instagramUser.position.y
      linkParam.zIn=this._appData.instagramUser.position.z
      linkParam.space=this._appData.instagramUser.space
    }
    else if (option=='out'){
      linkParam.xOut=this._appData.instagramUser.position.x
      linkParam.yOut=this._appData.instagramUser.position.y
      linkParam.zOut=this._appData.instagramUser.position.z
      linkParam.space=this._appData.instagramUser.space
    }
    else{
      linkParam.x=this._appData.instagramUser.position.x
      linkParam.y=this._appData.instagramUser.position.y
      linkParam.z=this._appData.instagramUser.position.z
      linkParam.space=this._appData.instagramUser.space
    }
    this.linkForm = this.fb.group(linkParam);
  }
  public processData(action){

    let linkParam = this.linkForm['_value'];
    if (!action){
      action={kind:'door',param:{}}
    }
    //senha e opcional: normaliza vazio/undefined para string vazia
    if (linkParam.password==null){
      linkParam.password='';
    }
    action.param=linkParam
    action.param.kind=this.option;
    if (this.option=='toRoom'){
      action.param.roomToGo=this.room.id
      action.param.space=this.space.id
    }
    if (this.option=='openClose'){
      action.param.teleport=true;
      action.param.x=0;
      action.param.y=0;
      action.param.z=0;
      action.param.roomToGo=this.room.id
      action.param.space=this.space.id
    }
    if (this.option=='teleport'){
      action.param.teleport=true;
      action.param.xIn=0;
      action.param.yIn=0;
      action.param.zIn=0;
      action.param.xOut=0;
      action.param.yOut=0;
      action.param.zOut=0;
      action.param.roomToGo=this.room.id
      action.param.space=this.space.id
    }
  }


  public childrenReloadData(){
    this.space=null;
    let myrooms=[];
    this.rooms.forEach(room=>{
         if (this.action.param && this.action.param.roomToGo && this.action.param.roomToGo==room.id) {
          this.room=room;
          this.selectRoom(this.room.id);
        }
        if (room.background2d && room.background2d.length>0){
          room.thumbnail=room.background2d[0].bg
        }
        if (room.backgroundPhoto && room.backgroundPhoto.length>0){
          room.thumbnail=room.backgroundPhoto[0].psma
        }
        if (room.background3d && room.background3d.length>0){
          room.thumbnail=room.background3d[0].img
        }
        if (room.id==this.action.param.roomToGo){
          room.selected=true;
        }
        myrooms.push(room);

      })
      this.rooms=myrooms;

    if (this.action.param) {
      if (!this.action.param.z){this.action.param.z=0}
      if (!this.action.param.zIn){this.action.param.zIn=0}
      if (!this.action.param.zOut){this.action.param.zOut=0}
      this.option=this.action.param.kind
      this.linkForm = this.fb.group({
        roomToGo:this.action.param.roomToGo ? this.action.param.roomToGo : '',
        teleport:false,
        direct:this.action.param.direct ? this.action.param.direct : false,
        x:this.action.param.x ? this.action.param.x : 0,
        y:this.action.param.y ? this.action.param.y : 0,
        z:this.action.param.z ? this.action.param.z : 0,
        xIn:this.action.param.xIn ? this.action.param.xIn : 0,
        yIn:this.action.param.yIn ? this.action.param.yIn : 0,
        zIn:this.action.param.zIn ? this.action.param.zIn : 0,
        xOut:this.action.param.xOut ? this.action.param.xOut : 0,
        yOut:this.action.param.yOut ? this.action.param.yOut : 0,
        zOut:this.action.param.zOut ? this.action.param.zOut : 0,
        space:this.action.param.space ? this.action.param.space : 0,
        nextAngle: this.action.param.nextAngle ? this.action.param.nextAngle : 0,
        voice:this.action.param.voice ? this.action.param.voice : false,
        password:this.action.param.password ? this.action.param.password : ''
      })
    }    

  }
  public selectOption(option){
    this.option=option

    
  }
    public ngOnInit(): any {
    }


}



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/+gameevent/actions/doorAction.ts